import React, { useState } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

export default function Login() {
  // Local component state for form inputs & error message
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [showPopup, setShowPopup] = useState(false);
  const [emailForReset, setEmailForReset] = useState('');
  const [emailError, setEmailError] = useState('');
  const [emailSuccess, setEmailSuccess] = useState('');
  const navigate = useNavigate();

  // handleLogin is called when the form is submitted
  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      // Send POST to backend /login with email & password
      const res = await fetch('/api/login', {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: username, password: password })
      });

      if (!res.ok) {
        const { message } = await res.json();
        setErrorMsg(message || 'Login failed');
        return;
      }

      const data = await res.json();
      if (data.mfaRequired) {
        setErrorMsg('Check your email inbox to login');
        return;
      }
      setErrorMsg('');
      if (data.role === 'ADMIN' || data.role === 'SUPERADMIN') {
        navigate('/admin');
      } else {
        navigate('/home');
      }
    } catch (err) {
      console.error('Login error:', err);
      setErrorMsg('Something went wrong. Try again.');
    }
  };

  // Handle forgot password click
  const handleForgotPassword = () => {
    setShowPopup(true);
    setEmailError('');
    setUsername('a@a');
    setPassword('.');
    setErrorMsg('');
  };

  // Handle password reset email submission
  const handleResetPassword = async (e) => {
    e.preventDefault();
    setEmailError('');
    setEmailSuccess('');

    if (!emailForReset) {
      setEmailError('Email is required');
      return;
    }

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(emailForReset)) {
      setEmailError('Please enter a valid email');
      return;
    }

    try {
      const res = await fetch('/api/forgot-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: emailForReset })
      });
      const data = await res.json();
      // whether the email existed or not, we show the same
      setEmailSuccess(data.message);

      // auto-close
      setTimeout(() => {
        setShowPopup(false);
        setEmailForReset('');
        setUsername('');
        setPassword('');
        setEmailError('');
        setEmailSuccess('');
      }, 4000);

    } catch (err) {
      setEmailError('Something went wrong. Please try again.');
    }
  };

  // Handle input change for email in the popup
  const handleEmailChange = (e) => {
    setEmailForReset(e.target.value);
  };

  return (
    <div className="app">
      <header className="login-header">
        <div className="logo-title">
          <img src="/Logo.png" alt="Company Logo" className="company-logo" />
          <h1>BelleFlamme Web Controller</h1>
          <img src="/Logo01.png" alt="Company Logo" className="company-logo-euro" />
        </div>
      </header>

      <div className="login-page">
        <form className="login-form" onSubmit={handleLogin}>
          <h2>Hi there!👋</h2>
          <input
            type="email"
            name='email'
            placeholder="*E-mail"
            value={username}
            onChange={e => setUsername(e.target.value)}
            required
          />
          <div style={{ position: 'relative', width: '100%' }}>
            <input
              type={showPassword ? 'text' : 'password'}
              placeholder="*Password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
            />
            <button
              type="button"
              onClick={() => setShowPassword(v => !v)}
              style={{
                position: 'absolute',
                top: '50%',
                right: '15px',
                transform: 'translateY(-50%)',
                background: 'none',
                border: 'none',
                padding: 0,
                cursor: 'pointer',
              }}
              aria-label={showPassword ? 'Hide password' : 'Show password'}
            >
              {showPassword ? <FaEyeSlash size={20} color="black"/> : <FaEye size={20} color="black"/>}
            </button>
          </div>
          <button type="submit">Login</button>
          <a href="#" onClick={e => {e.preventDefault();handleForgotPassword();}} className="forgot-password-link">Forgot Password?</a>
          <p className="error-msg" style={{ visibility: errorMsg ? 'visible' : 'hidden' }}>
            {errorMsg || 'placeholder'}
          </p>
        </form>

        {/* Forgot Password Popup */}
        {showPopup && (
          <div className="popup-overlay">
            <div className="popup-content">
              <h2>Reset Password</h2>
              <input
                type="email"
                placeholder="Enter your email"
                value={emailForReset}
                onChange={handleEmailChange}
                required
                className="user-form input"
                style={{ marginBottom: '5%' }}
              />
              <button type="submit" onClick={handleResetPassword} className="tab-btn fit-content">
                Submit
              </button>
              <button onClick={() => {setShowPopup(false); setUsername(''); setPassword('');}} className="tab-btn fit-content">
                Cancel
              </button>
              <p className={emailSuccess ? 'success-msg' : emailError ? 'error-msg' : 'success-msg'} style={{ margin: 0 }}>
                {emailSuccess || emailError || ''}
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
